export default {
  layout: {
    backToHome: 'กลับหน้าหลัก',
    legalDocuments: 'เอกสารทางกฎหมาย',
    product: 'ผลิตภัณฑ์',
    developers: 'นักพัฒนา',
    company: 'บริษัท',
    legal: 'กฎหมาย',
  },
  nav: {
    markets: 'ตลาด',
    aiAgents: 'AI Agents',
    vaults: 'Vaults',
    leaderboard: 'กระดานผู้นำ',
    fees: 'ค่าธรรมเนียม',
    apiReference: 'API Reference',
    sdks: 'SDK',
    about: 'เกี่ยวกับ ZhiSu',
    careers: 'ร่วมงานกับเรา',
    contact: 'ติดต่อเรา',
    press: 'สื่อและข่าวสาร',
    brand: 'แบรนด์ไกด์ไลน์',
    terms: 'ข้อกำหนดการให้บริการ',
    privacy: 'นโยบายความเป็นส่วนตัว',
    cookies: 'นโยบายคุกกี้',
    aml: 'นโยบาย AML',
    risk: 'การเปิดเผยความเสี่ยง',
    agreement: 'ข้อตกลงผู้ใช้',
    skills: 'ทักษะ',
  },
  table: {
    pair: 'คู่การเทรด',
    price: 'ราคา',
    change24h: '24ชม. เปลี่ยนแปลง',
    volume24h: '24ชม. ปริมาณ',
    funding: 'อัตราการระดมทุน',
    high24h: '24ชม. สูงสุด',
    low24h: '24ชม. ต่ำสุด',
    rank: 'อันดับ',
    trader: 'เทรดเดอร์',
    pnl30d: 'กำไร/ขาดทุน 30 วัน',
    winRate: 'อัตราชนะ',
    method: 'วิธี',
    endpoint: 'Endpoint',
    description: 'คำอธิบาย',
    auth: 'การยืนยันตัวตน',
    required: 'จำเป็น',
    none: 'ไม่มี',
    trades: 'จำนวนธุรกรรม',
    volume: 'ปริมาณการซื้อขาย',
    followers: 'ผู้ติดตาม',
  },
  common: {
    lastUpdated: 'อัปเดตล่าสุด',
  },
  markets: {
    title: 'ตลาด',
    subtitle: 'เทรดสัญญาซื้อขายล่วงหน้าแบบไม่มีวันหมดอายุบน 50+ คู่สกุลเงินดิจิทัล พร้อมเลเวอเรจสูงสุด 50 เท่า',
  },
  aiAgents: {
    title: 'AI Agents',
    subtitle: 'ปรับใช้ AI trading agents อัตโนมัติด้วยกลยุทธ์ machine learning',
    pnl30d: 'กำไร/ขาดทุน 30 วัน',
    winRate: 'อัตราชนะ',
    trades24h: 'การเทรด 24ชม.',
    risk: 'ความเสี่ยง',
    avgHold: 'ระยะเวลาถือเฉลี่ย',
  },
  vaults: {
    title: 'Vaults',
    subtitle: 'กลยุทธ์สร้างรายได้แบบอัตโนมัติพร้อมการจัดการความเสี่ยงในตัว',
    tvl: 'มูลค่าล็อกรวม',
    apy: 'ผลตอบแทนต่อปี',
    depositors: 'จำนวนผู้ฝาก',
    minDeposit: 'ยอดฝากขั้นต่ำ',
    riskLevel: 'ระดับความเสี่ยง',
    low: 'ต่ำ',
    medium: 'ปานกลาง',
    high: 'สูง',
  },
  leaderboard: {
    title: 'กระดานผู้นำ',
    subtitle: 'เทรดเดอร์ยอดเยี่ยมเรียงตามกำไร/ขาดทุน 30 วัน',
    allTime: 'ตลอดกาล',
    weekly: 'รายสัปดาห์',
  },
  fees: {
    title: 'ค่าธรรมเนียม',
    subtitle: 'โครงสร้างค่าธรรมเนียมที่โปร่งใสและแข่งขันได้สำหรับเทรดเดอร์ทุกคน',
    tier: 'ระดับ',
    maker: 'Maker',
    taker: 'Taker',
    volume30d: 'ปริมาณ 30 วัน',
    holderRequirement: 'ข้อกำหนด HOLDER',
    fundingRate: 'อัตราการระดมทุน',
    fundingLong: 'Long จ่าย Short เมื่อเป็นบวก',
    fundingShort: 'Short จ่าย Long เมื่อเป็นลบ',
    withdrawalFees: 'ค่าธรรมเนียมถอน',
    asset: 'สินทรัพย์',
    networkFee: 'ค่าธรรมเนียมเครือข่าย',
    minWithdrawal: 'ยอดถอนขั้นต่ำ',
    perpetualTrading: 'การเทรด Perpetual',
    interval: 'ระยะห่าง',
    settlement: 'การชำระเงิน',
    maxRate: 'อัตราสูงสุด',
  },
  apiReference: {
    title: 'API Reference',
    subtitle: 'เอกสาร REST API ฉบับสมบูรณ์สำหรับข้อมูลตลาด การเทรด และการจัดการบัญชี',
    baseUrl: 'Base URL',
    authentication: 'การยืนยันตัวตน',
    authDesc: 'Endpoint สาธารณะไม่ต้องการการยืนยันตัวตน Endpoint ที่ต้องการยืนยันตัวตนต้องส่ง API key ผ่าน header X-API-Key',
    rateLimits: 'ขีดจำกัดอัตรา',
    public: 'สาธารณะ',
    authenticated: 'ยืนยันตัวตนแล้ว',
    websocket: 'WebSocket',
    epMarkets: 'แสดงรายการตลาดการเทรดทั้งหมดที่มีให้ใช้งาน',
    epTicker: 'รับข้อมูล ticker 24 ชั่วโมงสำหรับตลาดเฉพาะ',
    epOrderbook: 'รับความลึกของ orderbook สำหรับตลาดเฉพาะ',
    epTrades: 'รับธุรกรรมล่าสุดสำหรับตลาดเฉพาะ',
    epAccount: 'รับยอดคงเหลือและตำแหน่งบัญชี',
    epOrders: 'สร้างคำสั่งซื้อใหม่',
    epCancelOrder: 'ยกเลิกคำสั่งซื้อที่มีอยู่',
    epOrdersList: 'แสดงรายการคำสั่งซื้อที่ใช้งานอยู่',
    epFills: 'รับประวัติการเติมเต็ม',
    epFundingRates: 'รับอัตราการระดมทุนปัจจุบันสำหรับตลาดทั้งหมด',
  },
  sdks: {
    title: 'SDK',
    subtitle: 'SDK อย่างเป็นทางการสำหรับ Python, TypeScript, Rust และ Go',
    install: 'ติดตั้ง',
    documentation: 'เอกสาร',
    pythonDesc: 'ไคลเอนต์ Python แบบฟังก์ชันครบถ้วนสำหรับ REST API และ WebSocket streaming รองรับ async/await, type hints และการเชื่อมต่ออัตโนมัติ',
    tsDesc: 'ไคลเอนต์ TypeScript/JavaScript สมัยใหม่ พร้อมความปลอดภัยของประเภทข้อมูลครบถ้วน ตรรกะการลองใหม่ในตัว และความเข้ากันได้กับเบราว์เซอร์/Node.js',
    rustDesc: 'ไคลเอนต์ Rust ประสิทธิภาพสูง ปรับแต่งสำหรับบอทเทรดแบบความหน่วงต่ำและกลยุทธ์เชิงปริมาณ',
    goDesc: 'ไคลเอนต์ Go น้ำหนักเบา พร้อมการสนับสนุน WebSocket แบบขนานและการจัดการหน่วยความจำที่มีประสิทธิภาพ สำหรับแอปพลิเคชันความถี่สูง',
  },
  about: {
    title: 'เกี่ยวกับ ZhiSu',
    subtitle: 'สร้างอนาคตของการเทรด derivatives แบบกระจายอำนาจ',
    ourValues: 'ค่านิยมของเรา',
    leadershipTeam: 'ทีมผู้นำ',
    backedBy: 'ผู้สนับสนุน',
    decentralization: 'การกระจายอำนาจ',
    decentralizationDesc: 'เราเชื่อในโลกที่ตลาดการเงินดำเนินการโดยไม่มีตัวกลาง ทุกการเทรดบน ZhiSu ชำระเงินบน on-chain ทำให้ผู้ใช้มีการควบคุมสินทรัพย์อย่างเต็มที่ตลอดเวลา',
    innovation: 'นวัตกรรม',
    innovationDesc: 'เราผลักดันขอบเขตของสิ่งที่เป็นไปได้ใน DeFi ตั้งแต่ AI-powered trading agents ไปจนถึง cross-chain liquidity aggregation เรากำลังสร้างโครงสร้างพื้นฐานสำหรับการเงินรุ่นต่อไป',
    transparency: 'ความโปร่งใส',
    transparencyDesc: 'การดำเนินงานโปรโตคอลทั้งหมด โครงสร้างค่าธรรมเนียม และการตัดสินใจด้าน governance เปิดเผยและตรวจสอบได้ สัญญาอัจฉริยะของเราได้รับการตรวจสอบอย่างเปิดเผย และ roadmap ของเราแบ่งปันกับชุมชน',
    security: 'ความปลอดภัย',
    securityDesc: 'ความปลอดภัยไม่ใช่สิ่งที่ทำภายหลัง รหัสของเราผ่านการตรวจสอบอิสระหลายครั้ง และเราดำเนินโครงการ bug bounty ที่ครอบคลุมเพื่อความปลอดภัยของเงินทุนผู้ใช้',
    founded: 'ก่อตั้งในปี 2024 ZhiSu เป็นตลาดซื้อขาย derivatives แบบกระจายอำนาจรุ่นใหม่ที่สร้างบนโครงสร้างพื้นฐานบล็อกเชนขั้นสูง',
    volume: 'ด้วยปริมาณการเทรดสะสมกว่า 2.8 พันล้านดอลลาร์ และระบบนิเวศของ AI-powered trading agents ที่เติบโตอย่างต่อเนื่อง ZhiSu กลายเป็นหนึ่งในแพลตฟอร์มที่ได้รับความไว้วางใจมากที่สุดในพื้นที่ DeFi',
    teamDesc: 'ทีมของเรารวมเอาความเชี่ยวชาญจากกองทุน hedge ระดับสูง สถาบันการเงินแบบดั้งเดิม และโปรโตคอลบล็อกเชนชั้นนำ',
    totalVolume: 'ปริมาณรวม',
    activeTraders: 'เทรดเดอร์ที่ใช้งาน',
    markets: 'จำนวนตลาด',
    countries: 'ประเทศ',
    ceo: 'ประธานเจ้าหน้าที่บริหาร',
    cto: 'ประธานเจ้าหน้าที่เทคโนโลยี',
    headProduct: 'หัวหน้าฝ่ายผลิตภัณฑ์',
    headAI: 'หัวหน้าฝ่ายวิจัย AI',
    clo: 'ประธานเจ้าหน้าที่กฎหมาย',
    headEng: 'หัวหน้าฝ่ายวิศวกรรม',
  },
  careers: {
    title: 'ร่วมงานกับเรา',
    subtitle: 'เข้าร่วมทีมที่สร้างโครงสร้างพื้นฐานการเทรด AI-native',
    openPositions: 'ตำแหน่งที่เปิดรับ',
    allDepartments: 'ทุกแผนก',
    engineering: 'วิศวกรรม',
    product: 'ผลิตภัณฑ์',
    design: 'ออกแบบ',
    marketing: 'การตลาด',
    operations: 'ปฏิบัติการ',
    legal: 'กฎหมาย',
    location: 'สถานที่',
    type: 'ประเภท',
    applyNow: 'สมัครเลย',
    benefits: 'ทำไมต้อง ZhiSu',
    benefit1Title: 'ค่าตอบแทนที่แข่งขันได้',
    benefit1Desc: 'เงินเดือนเหนือตลาด การจัดสรร token และโบนัสตามผลงาน',
    benefit2Title: 'Remote First',
    benefit2Desc: 'ทำงานจากที่ใดก็ได้ เราคือทีมที่กระจายอยู่ทั่วโลก',
    benefit3Title: 'เทคโนโลยีขั้นสูง',
    benefit3Desc: 'สร้างด้วยเทคโนโลยีล่าสุดใน AI, blockchain และ distributed systems',
    benefit4Title: 'การเติบโต',
    benefit4Desc: 'ความก้าวหน้าในอาชีพอย่างรวดเร็วในอุตสาหกรรมที่เติบโตอย่างรวดเร็ว',
  },
  contact: {
    title: 'ติดต่อเรา',
    subtitle: 'ติดต่อทีมของเรา',
    generalInquiries: 'สอบถามทั่วไป',
    support: 'ฝ่ายสนับสนุน',
    press: 'สื่อ',
    partnerships: 'พาร์ทเนอร์',
    sendMessage: 'ส่งข้อความ',
    name: 'ชื่อ',
    email: 'อีเมล',
    subject: 'หัวข้อ',
    message: 'ข้อความ',
    followUs: 'ติดตามเรา',
    response: 'โดยปกติเราจะตอบกลับภายใน 24 ชั่วโมง',
  },
  press: {
    title: 'สื่อและข่าวสาร',
    subtitle: 'ข่าวสารและประกาศล่าสุดจาก ZhiSu',
    mediaContact: 'ติดต่อสื่อ',
    pressEmail: 'press@zhisu.trade',
    readMore: 'อ่านเพิ่มเติม',
  },
  brand: {
    title: 'แบรนด์ไกด์ไลน์',
    subtitle: 'Brand assets อย่างเป็นทางการและแนวทางการใช้งาน',
    logoUsage: 'การใช้โลโก้',
    colorPalette: 'จานสี',
    typography: 'Typography',
    do: 'ทำ',
    dont: 'ไม่ทำ',
    primary: 'Primary',
    secondary: 'Secondary',
    background: 'พื้นหลัง',
    accent: 'เน้น',
    headingFont: 'ฟอนต์หัวข้อ',
    bodyFont: 'ฟอนต์เนื้อหา',
    monoFont: 'ฟอนต์ Mono',
    logoRules1: 'ใช้โลโก้บนพื้นหลังสีเข้มหรือสีอ่อนที่มีความคมชัดเพียงพอ',
    logoRules2: 'รักษาระยะห่างรอบโลโก้เท่ากับความสูงของเครื่องหมาย V',
    logoRules3: 'ใช้รูปแบบสีที่ให้ไว้สำหรับพื้นหลังที่แตกต่างกัน',
  },
  terms: {
    title: 'ข้อกำหนดการให้บริการ',
    s1: '1. การยอมรับข้อกำหนด',
    s2: '2. คุณสมบัติ',
    s3: '3. คำอธิบายบริการ',
    s4: '4. การลงทะเบียนบัญชีและความปลอดภัย',
    s5: '5. กฎการเทรดและความเสี่ยง',
    s6: '6. ค่าธรรมเนียมและการเรียกเก็บเงิน',
    s7: '7. กิจกรรมที่ห้าม',
    s8: '8. ทรัพย์สินทางปัญญา',
    s9: '9. การปฏิเสธการรับประกัน',
    s10: '10. การจำกัดความรับผิดชอบ',
    s11: '11. การชดใช้',
    s12: '12. กฎหมายที่ใช้บังคับและการแก้ไขข้อพิพาท',
    s13: '13. การแก้ไขข้อกำหนด',
    s14: '14. ข้อมูลการติดต่อ',
  },
  privacy: {
    title: 'นโยบายความเป็นส่วนตัว',
    s1: '1. บทนำ',
    s2: '2. ข้อมูลที่เรารวบรวม',
    s3: '3. วิธีการใช้ข้อมูลของคุณ',
    s4: '4. ฐานทางกฎหมายในการประมวลผล',
    s5: '5. การแบ่งปันและการเปิดเผยข้อมูล',
    s6: '6. ความปลอดภัยของข้อมูล',
    s7: '7. การเก็บรักษาข้อมูล',
    s8: '8. สิทธิของคุณ',
    s9: '9. การถ่ายโอนข้อมูลระหว่างประเทศ',
    s10: '10. ความเป็นส่วนตัวของเด็ก',
    s11: '11. การเปลี่ยนแปลงนโยบาย',
    s12: '12. ติดต่อเรา',
  },
  cookies: {
    title: 'นโยบายคุกกี้',
    s1: '1. คุกกี้คืออะไร',
    s2: '2. วิธีการใช้คุกกี้ของเรา',
    s3: '3. ประเภทของคุกกี้ที่เราใช้',
    s4: '4. คุกกี้ของบุคคลที่สาม',
    s5: '5. การจัดการการตั้งค่าคุกกี้',
    s6: '6. เว็บบีคอนและเทคโนโลยีที่คล้ายกัน',
    s7: '7. สัญญาณปฏิเสธการติดตาม',
    s8: '8. การเปลี่ยนแปลงนโยบาย',
    s9: '9. ติดต่อเรา',
  },
  aml: {
    title: 'นโยบาย AML',
    s1: '1. คำแถลงนโยบาย',
    s2: '2. กรอบกฎระเบียบ',
    s3: '3. การตรวจสอบลูกค้า (CDD)',
    s4: '4. การตรวจสอบอย่างต่อเนื่อง',
    s5: '5. กิจกรรมที่ห้าม',
    s6: '6. การปฏิบัติตามมาตรการคว่ำบาตร',
    s7: '7. การรายงานกิจกรรมที่น่าสงสัย',
    s8: '8. การเก็บบันทึก',
    s9: '9. การฝึกอบรมพนักงาน',
    s10: '10. การตรวจสอบโดยอิสระ',
    s11: '11. ติดต่อเรา',
  },
  risk: {
    title: 'การเปิดเผยความเสี่ยง',
    s1: '1. ประกาศสำคัญ',
    s2: '2. ไม่ใช่คำแนะนำทางการเงิน',
    s3: '3. ความเสี่ยงทางตลาด',
    s4: '4. ความเสี่ยงจากเลเวอเรจและมาร์จิ้น',
    s5: '5. ความเสี่ยงจากสมาร์ทคอนแทรกต์และเทคโนโลยี',
    s6: '6. ความเสี่ยงจาก AI Agent และการเทรดอัตโนมัติ',
    s7: '7. ความเสี่ยงจากการรักษาทรัพย์สินและกระเป๋าเงิน',
    s8: '8. ความเสี่ยงด้านกฎระเบียบและการปฏิบัติตาม',
    s9: '9. ความเสี่ยงด้านความปลอดภัยทางไซเบอร์',
    s10: '10. ความเสี่ยงการสูญเสียทั้งหมด',
    s11: '11. ไม่รับประกันความพร้อมใช้งานของแพลตฟอร์ม',
    s12: '12. การยอมรับ',
    s13: '13. ติดต่อเรา',
  },
  agreement: {
    title: 'ข้อตกลงผู้ใช้',
    s1: '1. ภาพรวมข้อตกลง',
    s2: '2. คำจำกัดความ',
    s3: '3. การเชื่อมต่อบัญชีและกระเป๋าเงิน',
    s4: '4. กฎการเทรด',
    s5: '5. ค่าธรรมเนียมและการชำระเงิน',
    s6: '6. AI Agent และบริการอัตโนมัติ',
    s7: '7. การใช้งาน API',
    s8: '8. การแสดงและการรับประกัน',
    s9: '9. การยกเลิก',
    s10: '10. การแก้ไขข้อพิพาท',
    s11: '11. การแก้ไข',
    s12: '12. ข้อตกลงฉบับสมบูรณ์',
    s13: '13. ติดต่อเรา',
  },
  skills: {
    title: 'ทักษะ',
    subtitle: 'ค้นพบและติดตั้งทักษะที่สร้างโดยชุมชนสำหรับ AI agents ของคุณ',
    searchPlaceholder: 'คุณกำลังมองหาอะไร?',
    install: 'ติดตั้ง',
    installNow: 'ติดตั้ง',
    categories: {
      all: 'ทั้งหมด',
      defi: 'DeFi & การเทรด',
      social: 'โซเชียล & ข้อความ',
      tools: 'การวิเคราะห์ & เครื่องมือ',
      other: 'อื่นๆ',
    },
    stats: {
      tools: 'เครื่องมือ',
      users: 'ผู้ใช้',
      downloads: 'ดาวน์โหลด',
      rating: 'คะแนนเฉลี่ย',
    },
    featuredSkills: 'ทักษะแนะนำ',
    trendingNow: 'กำลังฮิต',
    viewAll: 'ดูทั้งหมด',
    allSkills: 'ทักษะทั้งหมด',
    searchResults: 'ผลการค้นหา',
    noResults: 'ไม่พบทักษะที่ตรงกับเงื่อนไขของคุณ',
    builtByCommunity: 'สร้างโดยชุมชน',
    equip: 'ติดตั้ง',
    unleash: 'ปลดปล่อย',
    toolsReady: 'เครื่องมือที่นักพัฒนานับพันสร้างไว้ พร้อมใช้งานด้วยการค้นหาเพียงครั้งเดียว',
    installCommand: 'คำสั่งติดตั้ง',
    copied: 'คัดลอกแล้ว!',
    copy: 'คัดลอก',
    about: 'เกี่ยวกับ',
    usageExample: 'ตัวอย่างการใช้งาน',
    info: 'ข้อมูล',
    related: 'ทักษะที่เกี่ยวข้อง',
    backToSkills: 'กลับไปยังทักษะ',
    notFound: 'ไม่พบทักษะ',
    notFoundDesc: 'ทักษะที่คุณกำลังมองหาไม่มีอยู่',
  },
};